import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import AOS from 'aos';

export default function Talks() {
  const [topEvents, setTopEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTopEvents = async () => {
      try {
        const res = await fetch('https://sanjaydhir.com/api/events');
        const data = await res.json();
        
        if (Array.isArray(data)) {
          // Sort descending by date and take the top 3
          const sorted = data
            .sort((a, b) => new Date(b.date) - new Date(a.date))
            .slice(0, 3);
          setTopEvents(sorted);
        }
      } catch (err) {
        console.error('Failed to load events:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchTopEvents();
  }, []);
  useEffect(() => {
    if (!loading && topEvents.length > 0) {
      setTimeout(() => {
        AOS.refresh();
      }, 100);
    }
  }, [loading, topEvents]);

  return (
    <section className="container py-4 my-3 text-light">
      <div className="text-center mb-5" data-aos="fade-up">
        <h2 className="fw-bold text-gradient display-6">TALKS / EVENTS</h2>
        <p className="text-secondary mx-auto" style={{ maxWidth: '650px' }}>
          Keynotes, executive workshops, and global panel discussions on Strategic Innovation, Alliance Governance, and Public Policy Leadership.
        </p>
      </div>
      {loading ? (
        <div className="text-center text-secondary py-4">Loading latest events...</div>
      ) : topEvents.length === 0 ? (
        <div className="text-center text-secondary py-4">No events found.</div>
      ) : (
        <div className="row g-4 justify-content-center mb-4">
          {topEvents.map((event,idx) => {
            const displayImage =
              event.images && event.images.length > 0
                ? event.images[0]
                : 'https://via.placeholder.com/600x400/111827/ffffff?text=Event+Image';

            const formattedDate = new Date(event.date).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
            });

            return (
              <div key={event._id} className="col-12 col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay={idx * 150}>
                <div
                  className="card h-100 bg-dark text-light border-secondary shadow-sm d-flex flex-column overflow-hidden"
                  style={{
                    borderRadius: '12px',
                    transition: 'transform 0.25s ease, border-color 0.25s ease',
                    background: 'linear-gradient(180deg, #111827 0%, #0b0f19 100%)',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.borderColor = '#fbbf24';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.borderColor = '#4b5563';
                  }}
                >
                  {/* Event Thumbnail */}
                  <div style={{ height: '210px', width: '100%', overflow: 'hidden' }}>
                    <img
                      src={displayImage}
                      alt={event.title}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                      }}
                      onError={(e) => {
                        e.target.src =
                          'https://via.placeholder.com/600x400/111827/ffffff?text=Image+Unavailable';
                      }}
                    />
                  </div>

                  {/* Card Body */}
                  <div className="card-body d-flex flex-column p-4">
                    {/* Date Badge */}
                    <div className="mb-2">
                      <span
                        className="badge"
                        style={{
                          backgroundColor: 'rgba(251, 191, 36, 0.15)',
                          color: '#fbbf24',
                          border: '1px solid rgba(251, 191, 36, 0.4)',
                          fontSize: '12px',
                          padding: '5px 10px',
                          borderRadius: '6px',
                        }}
                      >
                        📅 {formattedDate}
                      </span>
                    </div>

                    {/* Title */}
                    <h5
                      className="card-title text-white fw-bold mb-2"
                      style={{
                        fontSize: '1.1rem',
                        lineHeight: '1.4',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        minHeight: '2.8rem',
                      }}
                    >
                      {event.title}
                    </h5>

                    {/* Description Snippet */}
                    <div
                      className="text-secondary small mb-3 flex-grow-1"
                      style={{
                        display: '-webkit-box',
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        lineHeight: '1.5',
                      }}
                      dangerouslySetInnerHTML={{ __html: event.description }}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Centered Explore More Button */}
      <div className="row justify-content-center">
        <div className="col-12 col-md-6 col-lg-4">
            <NavLink to="/TalksAndEvents" onClick={() => window.scrollTo(0, 0)} className="btn w-100 btn-outline-warning py-2 btn-hover-pop text-center">
                Explore More
            </NavLink>
        </div>
      </div>
    </section>
  );
}